<template>
  <layout-main-inner title="推送失败日志">
    <layout-card-wrap
      v-loading="loading"
      hasHeaderSlot>
      <template slot="form">
        <el-form
          label-width="60px"
          @submit.native.prevent>
          <el-row :gutter="20">
            <el-col :span="10">
              <el-form-item label="订单号:">
                <el-input
                  v-model="config.billNumber"
                  clearable=""
                  placeholder="请输入订单号"
                  @keyup.enter.native="handleCurrentChange(1)">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="收件人:">
                <el-input
                  v-model="config.receiver"
                  clearable=""
                  placeholder="请输入收件人姓名/手机号"
                  @keyup.enter.native="handleCurrentChange(1)">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item
                label=""
                label-width="0">
                <el-button
                  type="primary"
                  @click="handleCurrentChange(1)">查询</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </template>
      <el-table
        border
        :data="list">
        <el-table-column
          label="订单号"
          fixed="left"
          :resizable="false"
          width="170">
          <template slot-scope="{row}">
            <link-route>
              <span @click="linkto(row)">{{ row.billNumber }}</span>
            </link-route>
          </template>
        </el-table-column>
        <el-table-column
          label="收件人"
          min-width="140"
          :resizable="false">
          <template slot-scope="{row}">
            <span>{{ row.receiverName }}</span>-<span>{{ row.receiverPhone }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="订单来源"
          width="100"
          :resizable="false">
          <template slot-scope="{row}">
            {{ row.orderSource | sourceName() }}
          </template>
        </el-table-column>
        <el-table-column
          label="仓库"
          :resizable="false"
          min-width="120"
          prop="warehouseNo">
          <template slot-scope="{row}">
            {{ row.warehouseNo | warehouseName() }}
          </template>
        </el-table-column>
        <el-table-column
          label="错误信息"
          min-width="360">
          <template slot-scope="{row}">
            <div>
              <pre style="line-height: 20px;margin: 6px 0">{{ row.stopPushReason }}</pre>
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column
          label="响应内容"
          :resizable="false"
          min-width="380">
          <template slot-scope="{row}">
            <div>
              <span style="color:#000">响应数据：</span>
              <div>
                <pre style="line-height: 16px;margin: 0">{{ row.respMsg }}</pre>
              </div>
            </div>
            <div>
              <span style="color:#000">响应时间：</span>
              <div>{{ row.respTime | dateformat() }}</div>
            </div>
          </template>
        </el-table-column> -->
        <!-- <el-table-column
          label="操作信息"
          :resizable="false"
          width="150"
          prop="operationDesc">
          <template slot-scope="{row}">
            <div>
              <span style="color:#000">模块：</span>
              <span>{{ row.operationDesc }}</span>
            </div>
            <div>
              <span style="color:#000">动作：</span>
              <span>{{ row.operation }}</span>
            </div>
            <div>
              <span style="color:#000">人员：</span>
              <span>{{ row.userName }}</span>
            </div>
          </template>
        </el-table-column> -->
        <!-- <el-table-column
          label="动作"
          :resizable="false"
          width="70"
          prop="operation">
        </el-table-column>
        <el-table-column
          label="操作人员"
          :resizable="false"
          width="80"
          prop="userName">
        </el-table-column> -->
        <el-table-column
          label="开始推送时间"
          :resizable="false"
          width="140">
          <template slot-scope="{row}">
            {{ row.beginPushTime | dateformat() }}
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          fixed="right"
          width="80">
          <template slot-scope="{row}">
            <el-button
              type="warning"
              @click="deleteitem(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <template slot="footer">
        <pagination-new
          v-model="config"
          :total="total"
          :fetch="fetchList" />
      </template>
    </layout-card-wrap>
  </layout-main-inner>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'LooseTeaList',
  components: { },
  data() {
    return {
      loading: false,
      config: {
        pageNum: 1,
        pageSize: 10,
        billNumber: '',
        receiver: ''
      },
      list: [],
      total: 0
    }
  },
  computed: {
    ...mapState({
      userPermission: state => state.account.permission,
      query: state => state.common.query,
      userDetail: state => state.account.userDetail
    })
  },
  created() {
    if (this.query) {
      this.config = {
        ...this.config,
        ...this.query
      }
    }
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    deleteitem(row) {
      this.$confirm('此操作将永久删除该推送日志, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.loading = true
          this.$store.dispatch('common/deletestoppushedxsdd', {
            payload: {
              billNumber: row.billNumber
            },
            success: () => {
              this.loading = false
              this.fetchList()
            },
            fail: () => {
              this.loading = false
            }
          })
        })
    },
    linkto(row) {
      this.$store.dispatch('outstock/getsaleslist', {
        payload: {
          code: row.billNumber
        },
        success: (res) => {
          const id = res.data.data.records[0].id
          this.$router.push(`/orders-detail?salesOrderId=${id}&code=${row.billNumber}&activeName=1`)
        },
        fail: () => {}
      })
    },
    handleCurrentChange(current) {
      this.config.pageNum = current
      this.fetchList()
    },
    fetchList() {
      this.loading = true
      // this.$store.commit('common/setQuery', this.config)
      this.$store.dispatch('common/getstoppushedxsdds', {
        payload: this.config,
        success: (res) => {
          this.loading = false
          this.total = res.data.total
          this.list = res.data.records.map(i => {
            let stopPushReason = null
            try {
              stopPushReason = JSON.stringify(JSON.parse(i.stopPushReason), null, 2)
            } catch (error) {
              stopPushReason = i.stopPushReason
            }
            return {
              ...i,
              stopPushReason
            }
          })
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
